import { WILDCARD_CAMPAIGN_DETAILS_PATH } from '@/constants/paths';

export const createCampaignRedirectorPath = (campaignUid: string) =>
  WILDCARD_CAMPAIGN_DETAILS_PATH.replace(':id', campaignUid);
